import { Link } from "react-router-dom";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { cities } from "../../config/appData";
import { revokeBlobUrl } from "../hooks/useContentForm";

export function ContentFormShell({
  backTo,
  backLabel,
  title,
  subtitle,
  loading,
  loadError,
  loadErrorText,
  success,
  successTitle,
  successText,
  onAddAnother,
  children,
}) {
  return (
    <div className="admin-add-real-wedding admin-create-business-single">
      <div className="admin-page-header">
        <Link to={backTo} className="admin-back-link">
          {backLabel}
        </Link>
        <h1 className="admin-page-title">{title}</h1>
        <p className="admin-page-subtitle">{subtitle}</p>
      </div>
      <div className="admin-create-business-body admin-create-business-body-single">
        {loading ? (
          <div className="admin-step-content-card admin-create-business-card">
            <p>Loading...</p>
          </div>
        ) : loadError ? (
          <div className="admin-step-content-card admin-create-business-card">
            <p className="admin-form-error">{loadErrorText}</p>
            <Link to={backTo} className="admin-form-btn admin-form-btn-cancel">
              {backLabel}
            </Link>
          </div>
        ) : (
          <div className="admin-step-content-card admin-create-business-card admin-create-business-form-card">
            {success ? (
              <div className="admin-create-success-message">
                <h2 className="admin-create-success-title">{successTitle}</h2>
                <p className="admin-create-success-text">{successText}</p>
                <div className="admin-form-actions" style={{ border: "none", paddingTop: 0 }}>
                  <Link to={backTo} className="admin-form-btn admin-form-btn-submit">
                    {backLabel}
                  </Link>
                  <button
                    type="button"
                    className="admin-form-btn admin-form-btn-cancel"
                    onClick={onAddAnother}
                  >
                    Add another
                  </button>
                </div>
              </div>
            ) : (
              children
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export function ContentBasicFields({
  idPrefix,
  form,
  errors,
  postLoading,
  coverFile,
  coverInputRef,
  setField,
  handleCoverChange,
  removeCover,
}) {
  return (
    <div className="admin-form-section">
      <h3 className="admin-form-section-title">Basic info</h3>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label" htmlFor={`${idPrefix}-heading`}>
            Heading *
          </label>
          <input
            id={`${idPrefix}-heading`}
            type="text"
            className={`admin-form-input ${errors.heading ? "admin-form-input-error" : ""}`}
            value={form.heading}
            onChange={(e) => setField("heading", e.target.value)}
            placeholder="e.g. Beach Wedding at Sunset"
          />
          {errors.heading && <span className="admin-form-error">{errors.heading}</span>}
        </div>
      </div>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label" htmlFor={`${idPrefix}-city`}>
            City *
          </label>
          <select
            id={`${idPrefix}-city`}
            className={`admin-form-input ${errors.city ? "admin-form-input-error" : ""}`}
            value={form.city}
            onChange={(e) => setField("city", e.target.value)}
            disabled={postLoading}
          >
            <option value="">Select city</option>
            {cities.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
          {errors.city && <span className="admin-form-error">{errors.city}</span>}
        </div>
      </div>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label">Cover photo *</label>
          <div className="admin-image-upload-box admin-cover-upload-box">
            <input
              ref={coverInputRef}
              type="file"
              accept="image/*"
              className="admin-image-upload-input"
              onChange={handleCoverChange}
              aria-label="Cover photo"
            />
            {form.cover_photo || coverFile ? (
              <div className="admin-image-preview-wrap">
                <img src={form.cover_photo} alt="Cover" className="admin-image-preview" />
                <span className="admin-image-preview-label">Cover</span>
                <button
                  type="button"
                  className="admin-image-preview-remove"
                  onClick={removeCover}
                  disabled={postLoading}
                  aria-label="Remove cover image"
                >
                  ×
                </button>
              </div>
            ) : (
              <button
                type="button"
                className="admin-image-upload-placeholder"
                onClick={() => coverInputRef.current?.click()}
              >
                + Add cover image
              </button>
            )}
          </div>
          {errors.cover_photo && (
            <span className="admin-form-error">{errors.cover_photo}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export function ContentBlogMetaFields({ idPrefix, form, errors, setField }) {
  return (
    <>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label" htmlFor={`${idPrefix}-category`}>
            Category *
          </label>
          <input
            id={`${idPrefix}-category`}
            type="text"
            className={`admin-form-input ${errors.category ? "admin-form-input-error" : ""}`}
            value={form.category}
            onChange={(e) => setField("category", e.target.value)}
            placeholder="e.g. PLANNING"
          />
          {errors.category && <span className="admin-form-error">{errors.category}</span>}
        </div>
      </div>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label" htmlFor={`${idPrefix}-author`}>
            Author
          </label>
          <input
            id={`${idPrefix}-author`}
            type="text"
            className="admin-form-input"
            value={form.author}
            onChange={(e) => setField("author", e.target.value)}
            placeholder="e.g. WeddingzVenue Team"
          />
        </div>
      </div>
      <div className="admin-form-row">
        <div className="admin-form-group admin-form-group-full">
          <label className="admin-form-label" htmlFor={`${idPrefix}-read-time`}>
            Read time (minutes)
          </label>
          <input
            id={`${idPrefix}-read-time`}
            type="number"
            min={1}
            className="admin-form-input"
            value={form.read_time_minutes}
            onChange={(e) => setField("read_time_minutes", e.target.value)}
          />
        </div>
      </div>
      <div
        className="admin-form-section"
        style={{ marginTop: "1rem", paddingTop: "1rem", borderTop: "1px solid rgba(0,0,0,0.08)" }}
      >
        <h3 className="admin-form-section-title" style={{ marginBottom: "0.75rem" }}>
          SEO
        </h3>
        <div className="admin-form-row">
          <div className="admin-form-group admin-form-group-full">
            <label className="admin-form-label" htmlFor={`${idPrefix}-metatitle`}>
              SEO title
            </label>
            <input
              id={`${idPrefix}-metatitle`}
              type="text"
              className="admin-form-input"
              value={form.metatitle}
              onChange={(e) => setField("metatitle", e.target.value)}
              placeholder="SEO title (meta title)"
            />
          </div>
        </div>
        <div className="admin-form-row">
          <div className="admin-form-group admin-form-group-full">
            <label className="admin-form-label" htmlFor={`${idPrefix}-metadescp`}>
              SEO description
            </label>
            <textarea
              id={`${idPrefix}-metadescp`}
              className="admin-form-input"
              rows={3}
              value={form.metadescp}
              onChange={(e) => setField("metadescp", e.target.value)}
              placeholder="SEO description (meta description)"
            />
          </div>
        </div>
        <div className="admin-form-row">
          <div className="admin-form-group admin-form-group-full">
            <label className="admin-form-label" htmlFor={`${idPrefix}-slug`}>
              URL slug
            </label>
            <input
              id={`${idPrefix}-slug`}
              type="text"
              className="admin-form-input"
              value={form.slug}
              onChange={(e) => setField("slug", e.target.value)}
              placeholder="e.g. my-post-slug"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export function ContentDescriptionField({ idPrefix, form, errors, setField, placeholder }) {
  return (
    <div className="admin-form-row">
      <div className="admin-form-group admin-form-group-full">
        <label className="admin-form-label" htmlFor={`${idPrefix}-description`}>
          Description * (HTML)
        </label>
        <div
          className={`admin-html-editor-wrap ${errors.description ? "admin-form-input-error" : ""}`}
        >
          <ReactQuill
            theme="snow"
            value={form.description}
            onChange={(value) => setField("description", value)}
            placeholder={placeholder}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                ["clean"],
              ],
            }}
          />
        </div>
        {errors.description && (
          <span className="admin-form-error">{errors.description}</span>
        )}
      </div>
    </div>
  );
}

export function ContentGallerySection({
  form,
  errors,
  postLoading,
  galleryInputRefs,
  multiFileInputRef,
  setPhoto,
  handleGalleryChange,
  handleMultiSelect,
  addPhoto,
  removePhoto,
  sectionTitle = "Gallery photos",
}) {
  return (
    <div className="admin-form-section">
      <div className="admin-form-section-header">
        <h3 className="admin-form-section-title">{sectionTitle}</h3>
        <div className="admin-form-section-actions">
          <button type="button" className="admin-form-btn admin-form-btn-small" onClick={addPhoto}>
            + Add photo
          </button>
          <input
            ref={multiFileInputRef}
            type="file"
            accept="image/*"
            multiple
            className="admin-multi-file-input"
            onChange={handleMultiSelect}
            aria-label="Select multiple images"
          />
          <button
            type="button"
            className="admin-form-btn admin-form-btn-small admin-form-btn-outline"
            onClick={() => multiFileInputRef.current?.click()}
          >
            Select multiple images
          </button>
        </div>
      </div>
      {errors.wedding_photos && (
        <span className="admin-form-error" style={{ marginBottom: "0.5rem" }}>
          {errors.wedding_photos}
        </span>
      )}
      <div className="admin-real-wedding-photos-list admin-real-wedding-photos-grid">
        {form.wedding_photos.map((photo, index) => (
          <div key={index} className="admin-real-wedding-photo-card">
            <div className="admin-form-group admin-form-group-upload">
              <label className="admin-form-label admin-form-label-sr">Image {index + 1}</label>
              <div className="admin-image-upload-box admin-image-upload-box-grid">
                <input
                  ref={(el) => (galleryInputRefs.current[index] = el)}
                  type="file"
                  accept="image/*"
                  className="admin-image-upload-input"
                  onChange={(e) => handleGalleryChange(index, e)}
                  aria-label={`Gallery photo ${index + 1}`}
                />
                {photo.image_url ? (
                  <div className="admin-image-preview-wrap">
                    <img
                      src={photo.image_url}
                      alt={`Gallery ${index + 1}`}
                      className="admin-image-preview"
                    />
                    <span className="admin-image-preview-label">{index + 1}</span>
                    <button
                      type="button"
                      className="admin-image-preview-remove"
                      onClick={() => {
                        revokeBlobUrl(photo.image_url);
                        setPhoto(index, { file: null, image_url: "" });
                      }}
                      disabled={postLoading}
                      aria-label={`Remove image ${index + 1}`}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="admin-image-upload-placeholder"
                    onClick={() => galleryInputRefs.current[index]?.click()}
                  >
                    + Upload
                  </button>
                )}
              </div>
            </div>
            <div className="admin-real-wedding-photo-card-footer">
              <div className="admin-form-group admin-form-group-order">
                <label className="admin-form-label" htmlFor={`photo-order-${index}`}>
                  Order
                </label>
                <input
                  id={`photo-order-${index}`}
                  type="number"
                  min={0}
                  className="admin-form-input admin-form-input-order"
                  value={photo.display_order}
                  onChange={(e) =>
                    setPhoto(index, { display_order: parseInt(e.target.value, 10) || 0 })
                  }
                />
              </div>
              <button
                type="button"
                className="admin-form-btn admin-form-btn-small admin-form-btn-danger"
                onClick={() => removePhoto(index)}
                disabled={form.wedding_photos.length <= 1}
                aria-label="Remove photo"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
